import { render, staticRenderFns } from "./VContextComments.vue?vue&type=template&id=6137fc94&"
import script from "./VContextComments.vue?vue&type=script&lang=js&"
export * from "./VContextComments.vue?vue&type=script&lang=js&"
import style0 from "./VContextComments.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports